/* eslint-disable react-hooks/exhaustive-deps */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 15:10:17
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-08 10:31:52
 */
import { Pagination, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../app/store";
import styles from "./Factory.module.css";
import { FactoryQuerys } from "./query";
import { FactoryColumn } from "./columns";
import { FactoryParams } from "../../services/factory";
import { getFactoryListAsync,  selectFactoryList } from "./FactorySlice";
import { FactoryDetailModal } from "./modal";

export const FactoryMessage = () => {

  const dispatch = useDispatch<AppDispatch>();

  const data = useSelector(selectFactoryList);

  const [id, setId] = useState("")

  const [IsVisible, setIsVisible] = useState(false);

  const [queries, setQueries] = useState<FactoryParams>({
    pn: 1,
    ps: 10,
  });
  useEffect(() => {
    
    if (JSON.stringify(queries) !== "{}") {
      dispatch(getFactoryListAsync({ ...queries}));
    }
  }, [queries]);
  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          height: "120px",
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            flex: "1",
            background: "#fff",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <h3 style={{ fontWeight: "bold" }}>查询条件</h3>
          <FactoryQuerys
            onValueChange={(v) => {
              setQueries({...v,pn: 1, ps: 10});
            }}
          />
        </div>
      </div>
      <div
        style={{ height: "calc(100% - 130px)" }}
        className={styles.FactoryStation}
      >
        <div
          style={{
            width: "100%",
            height: "calc(100% - 55px)",
            overflow: "auto",
          }}
        >
          <Table
            rowKey={(record) => record.osId}
            className={styles.FactoryTable}
            pagination={false}
            style={{ height: "100%" }}
            dataSource={data.records}
            columns={FactoryColumn((text, osId,) => {
              if (text === "look"){
                setId(osId)
                setIsVisible(true);
              }else{
               return
              }
            }, data.size * (data.current - 1))}

          ></Table>
          <Pagination
            total={data.total}
            current={data.current}
            pageSize={data.size}
            showSizeChanger
            showQuickJumper
            style={{
              position: "absolute",
              bottom: "40px",
              right: "40px",
            }}
            showTotal={(total) => `共 ${total} 条`}
            onChange={(current, size) => {
              setQueries({ ...queries,  pn:current,  ps:size });
            }}
          />
        </div>
        <FactoryDetailModal
          visible={IsVisible}
          osId={id}
          onCancel={() => {
            setIsVisible(false);
          }}
          onOk={() => {
            setIsVisible(false);
            dispatch(
              getFactoryListAsync({ ...queries })
            );
          }}
        />
      </div>
    </div>
  );
};
